
<template>
  <div class="checkbox">
    <label
      :class="['checkbox__box',
      { 'checkbox__box--checked': checked, 'checkbox__box--disabled': disabled }]">
      <input :checked="checked" class="checkbox__input" type="checkbox" :disabled="disabled"
      @input="emits('update:checked', ($event.target as HTMLInputElement).checked)" />
      <tick-icon class="checkbox__checkmark" v-show="checked" />
    </label>
    <div :class="['checkbox__label', { 'checkbox__label--disabled': disabled }]" v-if="text">{{ text }} </div>
  </div>
</template>

<script setup lang="ts">
import TickIcon from '@/assets/TickIcon.svg'

const props = withDefaults(defineProps<{
  checked: boolean
  disabled?: boolean
  text?: string
}>(), {
  disabled: false
})

const emits = defineEmits<{
  (event: 'update:checked', checked: boolean): void
}>()

</script>
<style lang="scss">
.checkbox {
  display: flex;
  align-items: center;
  gap: 5px;

  &__box {
    position: relative;
    background-color: $black;
    height: 24px;
    width: 24px;
    border: 1px solid $grey-60;
    border-radius: 4px;
    cursor: pointer;
    width: 18px;
    height: 18px;
    transition: border-color 150ms $animationCurve;

    &:hover {
      border: 1px solid $white;
    }

    &--checked {
      &, &:hover {
        background-color: rgba($purple-dark, 50%);
        border: 1px solid $purple;
      }
    }

    &--disabled {
      &, &:hover {
        background-color: $black;
        border: 1px solid $grey-90;
        cursor: default;
      }
    }
  }

  &__checkmark {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  &__input {
    display: none
  }

  &__label {
    font-family: $font-regular;
    font-size: 12px;
    color: $white;
    &--disabled {
      opacity: 20%;
    }
  }
}
</style>
